import React, { useState } from 'react';
import { Input } from '@/shared/components/ui/Input';

interface PanelDomainsProps {
  domains: string[];
  onAdd: (domain: string) => void;
  onRemove: (domain: string) => void;
}

/** Domínios publicados do website (o preview {id}.website.* NÃO entra aqui). */
export const PanelDomains: React.FC<PanelDomainsProps> = ({ domains, onAdd, onRemove }) => {
  const [input, setInput] = useState('');

  const add = () => {
    const d = input.trim().toLowerCase();
    if (d && !domains.includes(d)) {
      onAdd(d);
      setInput('');
    }
  };

  return (
    <div className="space-y-4">
      {domains.map((domain) => (
        <div
          key={domain}
          className="flex items-center justify-between px-3 py-2 rounded-lg border"
          style={{ borderColor: 'var(--theme-card-border)', backgroundColor: 'var(--theme-card-background)' }}
          data-testid={`domain-item-${domain}`}
        >
          <span className="text-sm font-mono truncate" style={{ color: 'var(--theme-card-text)' }}>{domain}</span>
          <button
            type="button"
            onClick={() => onRemove(domain)}
            className="text-xs px-2 py-1 rounded hover:opacity-70 flex-shrink-0"
            style={{ color: '#ef4444' }}
            data-testid={`domain-remove-${domain}`}
          >
            Remover
          </button>
        </div>
      ))}

      <div className="flex gap-2">
        <Input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="meusite.com.br"
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
          data-testid="domain-input"
        />
        <button
          type="button"
          onClick={add}
          className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap"
          style={{ backgroundColor: 'var(--theme-button-primary)', color: 'var(--theme-button-primary-text)' }}
          data-testid="domain-add-button"
        >
          Adicionar
        </button>
      </div>
    </div>
  );
};
